/**
 * 深度复制
 * @param {*} data
 * @returns
 */
export function copy(data) {
  return JSON.parse(JSON.stringify(data))
}

/**
 * 获取url中的参数
 * @param {*} name
 * @param {*} url
 * @returns
 */
export function getUrlKey(name, url) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
}

/**
 * 生成get参数
 * @param {*} obj
 * @returns
 */
export function getparam(obj = {}) {
  var str = "?";
  obj['token'] = getToken();
  obj['uid'] = localStorage.getItem('id');
  for (var i in obj) {
    str += i;
    str += "=";
    str += obj[i];
    str += "&";
  }
  str = str.substring(0, str.length - 1);
  return str;
}

/**
 * 获得token
 * @returns
 */
export function getToken() {
  let token = localStorage.getItem("token")
  if (token === null || token == undefined || token == "undefined") {
    return ''
  }

  return token
}


/**
 * 将时间戳转为时间 1672531200000 -> 2024-01-01
 * @param {*} timestamp
 * @param {*} dateType
 * @returns
 */
export function timeFormat(timestamp, dateType = 'date') {

  // 时间格式化 2019-09-08
  let time = new Date(timestamp);
  let year = time.getFullYear();
  let month =
    time.getMonth() + 1 < 10
      ? "0" + (time.getMonth() + 1)
      : time.getMonth() + 1;
  let day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
  if (dateType == 'month') {
    return year + "-" + month;
  } else {
    return year + "-" + month + "-" + day;
  }
}


/**
 * 将数字转为大写
 * @param {*} num
 * @returns
 */
let ChinesNum = {
  1: "壹",
  2: "贰",
  3: "叁",
  4: "肆",
  5: "伍",
  6: "陆",
  7: "柒",
  8: "捌",
  9: "玖",
}

export function toChinesNum(num) {
  if (num in ChinesNum) {
    return ChinesNum[num]
  } else {
    return '零'
  }

}

export default {
  timeFormat,
  toChinesNum,
  copy
}

export function getEnumValueByKey(arr, targetValue, keyToFind = 'value', keyToReturn = 'label') {
  const item = arr.find(obj => obj[keyToFind] === targetValue);
  return item ? item[keyToReturn] : undefined;
}

export function isEmpty(value) {
  // 处理 null 和 undefined
  if (value == null) return true;

  // 处理原始类型
  switch (typeof value) {
    case 'string':
      return value.trim().length === 0;
    case 'number':
    case 'boolean':
    case 'function':
    case 'symbol':
      return false;
  }

  // 处理引用类型
  if (Array.isArray(value) ||
    typeof value === 'object' && Symbol.iterator in value) {
    return value.length === 0; // 支持 Array/String/TypedArray/Arguments等
  }

  // 处理普通对象 (排除特殊对象如 Date/RegExp)
  if (Object.prototype.toString.call(value) === '[object Object]') {
    return Object.keys(value).length === 0;
  }

  // 处理 Map/Set
  if (value instanceof Map || value instanceof Set) {
    return value.size === 0;
  }

  // 其他未覆盖类型默认非空
  return false;
}

// 传入url导出文件
export function exportExcel(url) {
  // 判断是否为图片URL（根据扩展名简单判断，实际可结合Content-Type）
  const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(url);

  if (isImage) {
    // 图片类型：在新窗口打开
    const newWindow = window.open(url, '_blank');
    if (!newWindow) {
      console.error('弹窗被浏览器阻止，请允许弹窗或手动打开链接。');
    }
  } else {
    // 非图片类型
    const link = document.createElement('a');
    link.href = url;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

export function scrollToHash(hash) {
  if (!hash) return
  const id = hash.replace('#', '')

  // 查找目标元素
  const targetElement = document.getElementById(id)
  if (targetElement) {
    // 平滑滚动到目标位置
    targetElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }
}

// ... existing code ...

/**
 * 检测设备类型
 * @returns {string} 'mobile' | 'desktop'
 */
export function detectDeviceType() {
  // 1. 优先使用 UserAgent 检测（最可靠）
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileUA = /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

  // 2. 检测触摸支持
  const hasTouch = 'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    (navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0);

  // 3. 检测屏幕尺寸（使用 window.innerWidth 而不是 screen）
  const screenWidth = window.innerWidth;

  // 4. 综合判断
  // 如果是移动设备 UA，直接返回 mobile
  if (isMobileUA) {
    return 'mobile';
  }

  // 如果有触摸且屏幕宽度小于断点，认为是移动设备
  if (hasTouch && screenWidth < 768) {
    return 'mobile';
  }

  // 如果屏幕宽度小于断点，也认为是移动设备
  if (screenWidth < 768) {
    return 'mobile';
  }

  // 默认返回 desktop
  return 'desktop';
}

// ... existing code ...
